import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import 'rxjs/add/operator/toPromise';

import * as ent from '../entities/index'
import * as filters from '../filters/index'
import * as serv from '../services/index'

import { ConfigService } from '../services/Config.service';

@Injectable()
export class AdminService {

    private baseAdminURL = "/Admin";  // URL to web api
    private getImportAuditsURL = '';
    private getLogMessagesURL = '';
    private saveUserMessageURL = '';
    private saveAppSettingValueURL = '';
    private getSalesOfficeRequestTypesURL = '';
    private saveSalesOfficeRequestTypesURL = '';


    appConfig: ent.AppConfig;

    constructor(private httpClient: HttpClient, private configService: ConfigService) {
        this.baseAdminURL = this.configService.appConfig.UrlBase + this.baseAdminURL;
        this.getImportAuditsURL = this.baseAdminURL + '/GetImportAudits';
        this.getLogMessagesURL = this.baseAdminURL + '/GetLogMessages';
        this.saveUserMessageURL = this.baseAdminURL + '/SaveUserMessage';
        this.saveUserMessageURL = this.baseAdminURL + '/SaveUserMessage';
        this.saveAppSettingValueURL = this.baseAdminURL + '/SaveAppSettingValue';
        this.getSalesOfficeRequestTypesURL = this.baseAdminURL + '/GetSalesOfficeRequestTypes';
        this.saveSalesOfficeRequestTypesURL = this.baseAdminURL + '/SaveSalesOfficeRequestTypes';
    }

    getImportAudits(request: ent.GetDataRequest): Observable<ent.ImportAudit[]> {
        return this.httpClient.post<ent.ImportAudit[]>(this.getImportAuditsURL, request);
    }

    getLogMessages(filter: filters.LogMessageFilter): Observable<ent.LogMessage[]> {
        return this.httpClient.post<ent.LogMessage[]>(this.getLogMessagesURL, filter);
    }

    saveUserMessage(request: ent.SaveUserMessageRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveUserMessageURL, request);
    }

    saveAppSettingValue(request: ent.SaveAppSettingRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveAppSettingValueURL, request);
    }
    getSalesOfficeRequestTypes(filter: filters.SalesOfficeRequestTypeFilter): Observable<ent.SalesOfficeRequestType[]> {
        return this.httpClient.post<ent.SalesOfficeRequestType[]>(this.getSalesOfficeRequestTypesURL, filter);
    }
    saveSalesOfficeRequestTypes(request: ent.SaveSalesOfficeRequestTypesRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveSalesOfficeRequestTypesURL, request);
    }

}
